import React from 'react';
import { connect } from 'react-redux'
import ClientSearch from './ClientSearch.jsx';

//Importación de actions.
import {
    getScreenData,
    routeToClientView,
    cambiarBusqueda,
    obtenerClienteListado,
    buscarPorNombre,
    buscarClientePorNroCli,
    buscarPorCuit,
    setClienteTarjetas,
    resetStateBusquedaCliente,
    buscarPorDni,
    seleccionarCliente
} from '../actions/Actions.js';


const mapStateToProps = (state) => {

    //state.busquedaCliente.lastProgram = state.menuProductos.lastProgram;

    return {
        data: state.busquedaCliente.data,
        isFetching: state.busquedaCliente.isFetching,
        error: state.busquedaCliente.error
    }
}

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        getScreenData: (state, currentScope) => {
            dispatch(getScreenData(state, currentScope));
        },
        routeToClientView: (request) => {
            dispatch(routeToClientView(request));
        },
        cambiarBusqueda: (val) => {
            dispatch(cambiarBusqueda(val));
        },
        obtenerClienteListado: (id, clientes) => {
            dispatch(obtenerClienteListado(id, clientes));
        },
        buscarPorNombre: (val) => {
            dispatch(buscarPorNombre(val));
        },
        buscarClientePorNroCli: (cliente) => {
            dispatch(buscarClientePorNroCli(cliente));
        },
        buscarPorCuit: (doc, esAdicional) => {
            dispatch(buscarPorCuit(doc, esAdicional));
        },
        buscarPorDni: (doc, esAdicional) => {
            dispatch(buscarPorDni(doc, esAdicional));
        },
        setClienteTarjetas: (cliente) => {
            dispatch(setClienteTarjetas(cliente));
        },
        resetStateBusquedaCliente: () => {
            dispatch(resetStateBusquedaCliente());
        },
        seleccionarCliente: (clienteSeleccionado, valueSearch, programaSelccionado) => {
            dispatch(seleccionarCliente(clienteSeleccionado, valueSearch, programaSelccionado));
        }
    }
}

//Connect entre el componente y las props y actions.
const ClientSearchContainer = connect(mapStateToProps, mapDispatchToProps)(ClientSearch);

export default ClientSearchContainer;